import React, { FunctionComponent } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { EventSection } from 'src/components/calendar/eventSection'
import { CollapsibleHTMLContent } from './CollapsibleHTMLTextContent/CollapsibleHTMLContent'
import { ACCESSIBILITY_DESCRIPTION_ID, DESCRIPTION_SANITIZATION_CONFIG } from './constants'

import locale from './locale'
import { DescriptionPlaceholder } from './Description'

interface Props {
  eventData: any,
  isMobile: Boolean,
  loading: Boolean,
}

const AccessibilityDescriptionComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  eventData,
  isMobile,
  loading,
  intl: { formatMessage },
}) => {
  if (loading) return <DescriptionPlaceholder />;
  if (!eventData?.accessibilityDescription) return <></>;
  return (
    <EventSection sectionId={ACCESSIBILITY_DESCRIPTION_ID} heading={formatMessage(locale.accessibilityDescription)}>
      <CollapsibleHTMLContent
        htmlContent={eventData.accessibilityDescription}
        htmlSanitizationConfig={DESCRIPTION_SANITIZATION_CONFIG}
        isMobile={isMobile}
        maxHeight={40}
        alwaysCollapseAtMaxHeight
      />
    </EventSection>
  );
}

export const AccessibilityDescription = injectIntl(AccessibilityDescriptionComponent)
